import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import type { Section } from '@/types';

interface LayoutProps {
    currentSection: Section;
    onSectionChange: (section: Section) => void;
    onLogout: () => void;
    onRefresh?: () => void;
    loading?: boolean;
    children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({
                                                  currentSection,
                                                  onSectionChange,
                                                  onLogout,
                                                  onRefresh,
                                                  loading = false,
                                                  children,
                                              }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleMenuClick = () => {
        setSidebarOpen(true);
    };

    const handleSidebarClose = () => {
        setSidebarOpen(false);
    };

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Sidebar */}
            <Sidebar
                currentSection={currentSection}
                onSectionChange={onSectionChange}
                onLogout={onLogout}
                isOpen={sidebarOpen}
                onClose={handleSidebarClose}
            />

            {/* Main content */}
            <div className="lg:pl-64 flex flex-col flex-1">
                {/* Header */}
                <Header
                    currentSection={currentSection}
                    onMenuClick={handleMenuClick}
                    onRefresh={onRefresh}
                    loading={loading}
                />

                {/* Page content */}
                <main className="flex-1">
                    <div className="py-6">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            {children}
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
